export enum POSITION {
  SENDING = 1,
  RECEIVING = 2,
}
